/*
 *
 * Page - Wallpaper Calculator & logic for Product modal popup
 *
 * */
$(function(){
  if ($('.kp_wallpaper_roll_calc').length || $('body .product-page').length) {
    
      var wallpaperCalculator = (function() {
          /* HM: Constants and variables used by multiple functions, add the total area of Walls  and subtract the total area
          of any non-wallpapered Features. This is where the final output is stored before being shown to the user. */
          var data = {
              totalArea: 0,
              totalFeatureArea: 0,
              numberOfWalls: 1,
              numberOfFeatures: 0,
              summedAreaInFeet: 0,
              summedAreaInMetres: 0,
              totalRolls: 0,
              totalTins: 0,
              calculateTotalArea: function(surfaceAreas) {
                  var calculatedTotal = surfaceAreas.reduce(function(accumulator, current) {
                      return Number(accumulator) + Number(current);
                  });
                  return calculatedTotal;
              },
              deductFeatureArea: function() {
                  var subtractFeatures = Math.max(this.totalArea - this.totalFeatureArea, 0);
                  this.summedAreaInFeet = this.metric ? subtractFeatures / this.sqFeetToMetres : subtractFeatures;
                  this.summedAreaInMetres = this.metric ? subtractFeatures : subtractFeatures * this.sqFeetToMetres;
                  // HM: Arbitrary 10% added to total to simulate wastage and match up with reference PDF
                  this.totalRolls = this.summedAreaInMetres / this.rollSurface + ((this.summedAreaInMetres / this.rollSurface) * 0.05);
                  this.artistickRolls = this.summedAreaInMetres / this.artistickRollSurface + ((this.summedAreaInMetres / this.artistickRollSurface) * 0.05);
                  this.totalTins = this.summedAreaInMetres / this.tinSurface + ((this.summedAreaInMetres / this.tinSurface) * 0.05);
              },
              metric: true,
              rollSurface: 5.3265, // HM: The surface area of a roll in metres square, provided by client
              artistickRollSurface: 3.18, // HM: The surface area of a roll in metres square, provided by client
              tinSurface: 40, // HM: The surface area of a tin of paint in metres square, provided by client
              sqFeetToMetres: 0.092903 // HM: All inputs in feet are converted to metres to be divided by figure above
          };
  
          /* HM: Below returns HTML elements as string to pass to Jquery for adding to DOM, needs to be created with right info
          to reflect how many walls there are and whether using metric or feet */
  
          var inputHTML = function(numberOfWalls) {
              var isMetresOrFeet = data.metric ? 'metres' : 'feet';
              return (
                  '<div class="eh-calculator-left-content wall-input d-flex flex-column flex-sm-row flex-md-column flex-lg-row align-items-sm-center align-items-md-start align-items-lg-center gap-2  pb-2"><span>Wall ' + numberOfWalls + '</span><div class="input-groups  d-flex flex-row align-items-center gap-2"><input type="number" name="height" id="wall-' +
                  numberOfWalls +
                  '-height" min="2" max="10" value="2" step="0.1" class="form-control input  mb-0" ><span class="dimensions ' + isMetresOrFeet + '">Height</span></div><div class="input-groups  d-flex flex-row align-items-center gap-2"><input type="number" name="distance" id="wall-' +
                  numberOfWalls +
                  '-distance" min="3" max="86" value="3" step="0.5" class="form-control input  mb-0"><span class="dimensions ' + isMetresOrFeet + '">Width</span></div></div>'
              );
          };
  
          var featureHTML = function(numberOfFeatures) {
              var isMetresOrFeet = data.metric ? 'metres' : 'feet';
              return (
                  '<div class="eh-calculator-right-content feature-input d-flex flex-column flex-sm-row flex-md-column flex-lg-row align-items-sm-center align-items-md-start align-items-lg-center gap-2  pb-2"><span>Feature ' + numberOfFeatures + '</span><div class="input-groups  d-flex flex-row align-items-center gap-2"> <input type="number" name="height" id="feature-' +
                  numberOfFeatures +
                  '-height" min="2" max="10" value="2" step="0.1" class="form-control input  mb-0" ><span class="dimensions ' + isMetresOrFeet + '">Height</span></div><div class="input-groups  d-flex flex-row align-items-center gap-2"> <input type="number" name="distance" id="feature-' +
                  numberOfFeatures +
                  '-distance" min="3" max="86" value="3" step="0.5" class="form-control input  mb-0"><span class="dimensions ' + isMetresOrFeet + '">Width</span></div></div>'
              );
          };
  
          /* HM: This is something of a "fat function", if user wants to change or expand the calculator this may
           * need breaking up, have highlighted some parts that are less than ideal. */
          var surfaceCalculation = function() {
              var heightAsNumber, distanceAsNumber, outputString, roundedRollTotal, roundedArtistickRollTotal, roundedTinTotal, rollOrTin, totalRollOrTin, requiredTotal;
              var wallArea = [];
              var featureArea = [];
              var productType = $('#calculator-modal').attr('data-calculator-type');
              /* HM: Input elements are the main data source for current dimensions, this function is triggered by updates
               * to those same inputs. */
              $(".wall-input").each(function() {
                  heightAsNumber = parseFloat(
                      $(this)
                      .find('input[name="height"]')
                      .val()
                  );
                  distanceAsNumber = parseFloat(
                      $(this)
                      .find('input[name="distance"]')
                      .val()
                  );
                  wallArea.push(Number(heightAsNumber * distanceAsNumber).toPrecision(4));
              });
  
              data.totalArea = data.calculateTotalArea(wallArea);
  
              $(".feature-input").each(function() {
                  heightAsNumber = parseFloat(
                      $(this)
                      .find('input[name="height"]')
                      .val()
                  );
                  distanceAsNumber = parseFloat(
                      $(this)
                      .find('input[name="distance"]')
                      .val()
                  );
                  featureArea.push(Number(heightAsNumber * distanceAsNumber).toPrecision(4));
              });
  
              if (featureArea.length > 0) {
                  data.totalFeatureArea = data.calculateTotalArea(featureArea);
              } else {
                  data.totalFeatureArea = 0;
              }
  
              data.deductFeatureArea();
              roundedTinTotal = Math.ceil(data.totalTins);
              roundedArtistickRollTotal = Math.ceil(data.artistickRolls);
              roundedRollTotal = Math.ceil(data.totalRolls);
  
              // HM: Different calculations for paint products and wallpaper
              if (productType === 'Paint') {
                  // HM: Simple static string makes for better explanation when 0 or 1 tins are required
                  switch (roundedTinTotal) {
                      case 0:
                          outputString = 'Dimensions too small, you need less than a single tin.';
                          break;
                      case 1:
                          outputString = 'A single tin is enough.';
                          break;
                      default:
                          outputString = roundedTinTotal.toString() + ' ' + 'tins are required.';
                  }
              } else if (productType === 'Peel & Stick') {
                  switch (roundedArtistickRollTotal) {
                      case 0:
                          outputString = 'Dimensions too small, you need less than a single roll.';
                          break;
                      case 1:
                          outputString = 'A single roll is enough.';
                          break;
                      default:
                          outputString = roundedArtistickRollTotal.toString() + ' ' + 'Artistick rolls required.';
                  }
              } else {
                  // HM: Simple static string makes for better explanation when 0 or 1 tins are required
                
                  switch (roundedRollTotal) {
                      case 0:
                          outputString = 'Dimensions too small, you need less than a single roll.';
                          break;
                      case 1:
                          outputString = 'A single roll is enough.';
                          break;
                      default:
                          outputString = roundedRollTotal.toString() + ' ' + 'rolls are required.';
                  }
              }
  
  
    
              $("#calculator-output").text(outputString);
              // HM: Feedback approximate surface area, rounded and truncated, to user
              $("#surface-area").text(Math.round(data.metric ? data.summedAreaInMetres : data.summedAreaInFeet).toFixed().toString());
          };
  
          var setMetricImperialLimits = function(feetOrMetres, measurementChanged, elementAffected) {
              // HM: Metres
              if (feetOrMetres === true) {
                  $("#measurement").text("feet");
                  $("#surface-measurement").text('metres');
                  $(".dimensions").each(function() {
                          $(this).removeClass('feet').addClass('metres')
                      })
                      // HM: Feet
              } else {
                  $("#measurement").text("metres");
                  $("#surface-measurement").text('feet');
                  $(".dimensions").each(function() {
                      $(this).removeClass('metres').addClass('feet')
                  })
              }
  
              // HM: When Wall or Feature is created the new element is passed here to give it different default values for feet or metres
              if (elementAffected) {
                  elementAffected
                      .find('input[name="height"]')
                      .val(feetOrMetres ? 2 : 7);
                  elementAffected
                      .find('input[name="distance"]')
                      .val(feetOrMetres ? 3 : 10);
              }
  
              /* HM: Set sensible min, max, step values for the different measurements, also change the values if the user
              has switched the metric around */
              function changeMinMaxResetValues(elementToChange) {
                  $(elementToChange)
                      .find('input[name="height"]')
                      .attr({
                          max: feetOrMetres ? 3 : 10,
                          min: feetOrMetres ? 2 : 7,
                          step: feetOrMetres ? 0.1 : 0.5
                      });
                  $(elementToChange)
                      .find('input[name="distance"]')
                      .attr({
                          max: feetOrMetres ? 30 : 90,
                          min: feetOrMetres ? 3 : 10,
                          step: 0.5
                      });
                  if (measurementChanged) {
                      $(elementToChange)
                          .find('input[name="height"]')
                          .val(feetOrMetres ? 2 : 7);
                      $(elementToChange)
                          .find('input[name="distance"]')
                          .val(feetOrMetres ? 3 : 10);
                  }
              }
  
              $(".wall-input").each(function() {
                  changeMinMaxResetValues(this);
              });
  
              $(".feature-input").each(function() {
                  changeMinMaxResetValues(this);
              });
  
          };
  
          $(document).ready(function() {
  
              /* HM: When the page is loaded calculate the rolls for default input and add listeners that add/remove
               * walls & features, then make sure correct metric is used, then calculate rolls. */
  
              // HM: The page renders a wall-input from the document, saves the element flashing in on a Jquery append
              $('.wall-input').first().change(function() {
                  surfaceCalculation();
              });
  
              surfaceCalculation();
  
              $("#add-inputs").click(function() {
                  // HM: Maximum of 4 walls
                  if (data.numberOfWalls < 4) {
                      data.numberOfWalls++;
                      $(inputHTML(data.numberOfWalls))
                          .hide()
                          .appendTo("#inputs")
                          .change(function() {
                              surfaceCalculation();
                          })
                          .fadeIn(500);
                      setMetricImperialLimits(data.metric, false, $(".wall-input").last());
                      surfaceCalculation();
                  }
              });
  
              $("#add-features").click(function() {
                  if (data.numberOfFeatures < 4) {
                      data.numberOfFeatures++;
                      $(featureHTML(data.numberOfFeatures))
                          .hide()
                          .appendTo("#features")
                          .change(function() {
                              surfaceCalculation();
                          })
                          .fadeIn(500);
                      setMetricImperialLimits(data.metric, false, $(".feature-input").last());
                      surfaceCalculation();
                  }
              });
  
              $("#remove-inputs").click(function() {
                  if (data.numberOfWalls > 1) {
                      $(".wall-input")
                          .last()
                          .remove();
                      data.numberOfWalls--;
                      surfaceCalculation();
                  }
              });
  
              $("#remove-features").click(function() {
                  if (data.numberOfFeatures > 0) {
                      $(".feature-input")
                          .last()
                          .remove();
                      data.numberOfFeatures--;
                      surfaceCalculation();
                  }
              });
  
              $("#convert").click(function() {
                  data.metric = !data.metric;
                  setMetricImperialLimits(data.metric, true);
                  surfaceCalculation();
              });
  
          });
      })();
  }
  
  function wallpaperCalculatorModal() {
      // Get the modal with jQuery methods for animation
      var modal = $('#calculator-modal');
      // Target to close the window when user clicks outside
      var modalWindow = document.getElementById("calculator-modal");
  
  // Get the button that opens the modal
    if ($('body #calculator-btn').length) {
      var btn = document.getElementById("calculator-btn");

      // When the user clicks on the button, open the modal
    
      btn.onclick = function() {
              modal.fadeIn(500).css("display","block");
      }
    }
  
  // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("calculator-close")[0];
  
  
  
  // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
              modal.fadeOut(500).css("display","none");
      }
  
  // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
          if (event.target == modalWindow) {
              modal.fadeOut(500).css("display","none");
          }
      }
  }
  
  if ($('body .product-page').length) {
    wallpaperCalculatorModal();
  }

  //$('.res-img-loaded').BUP('rightImg', 1)
  $('.product-media .kp-zoom-image').zoom({
      magnify: 2
    });

  async function load() {
      let url = 'https://uk-arthouse.myshopify.com/browsing_context_suggestions.json';
      let obj = await (await fetch(url)).json();
      let current_country_code = $('#country_code').val();
      if(obj.detected_values.country_name=='United States' && current_country_code!=='US'){
        $('#country_code').val('US');
        $('#currency-switcher').submit();
        window.alert(obj.detected_values.country_name);
      }
      
  }
  
  //load();

  
  
});